import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "/backend";

export default function AdminTestimonials() {
  // auth
  const [logged, setLogged] = useState(false);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  // data
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 10;

  // ---- AUTH ----
  const login = async (e) => {
    e.preventDefault();
    const res = await fetch(`${API_BASE}/auth/login.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: u, password: p }),
    });
    const js = await res.json();
    if (js.success) setLogged(true);
    else alert(js.message || "Credenciales inválidas");
  };

  const logout = async () => {
    await fetch(`${API_BASE}/auth/logout.php`, {
      method: "POST",
      credentials: "include",
    });
    setLogged(false);
    setRows([]);
  };

  // ---- LIST ----
  const load = async (pg = 1) => {
    const url = new URL(`${API_BASE}/api/admin_list_testimonios.php`, window.location.origin);
    url.searchParams.set("page", pg);
    url.searchParams.set("limit", limit);
    if (q) url.searchParams.set("q", q);

    const res = await fetch(url, { credentials: "include", cache: "no-store" });
    const js = await res.json();
    if (js.success) {
      setRows(js.data);
      setTotal(js.total);
      setPage(js.page);
    } else {
      if (res.status === 401) setLogged(false);
      else alert(js.message || "Error al cargar");
    }
  };

  useEffect(() => {
    if (logged) load(1);
  }, [logged]); // carga al loguearte

  // ---- UPDATE ----
  const save = async (r) => {
    const fd = new FormData();
    fd.append("id", r.id);
    fd.append("nombre", r.nombre);
    fd.append("mensaje", r.mensaje);
    if (r._file) fd.append("avatar", r._file);

    const res = await fetch(`${API_BASE}/api/admin_update_testimonio.php`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    const js = await res.json();
    if (js.success) {
      alert("Guardado");
      load(page);
    } else {
      alert(js.message || "No se pudo guardar");
    }
  };

  // ---- DELETE ----
  const delRow = async (id) => {
    if (!window.confirm("¿Eliminar este testimonio?")) return;
    const fd = new FormData();
    fd.append("id", id);

    const res = await fetch(`${API_BASE}/api/admin_delete_testimonio.php`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    const js = await res.json();
    if (js.success) load(page);
    else alert(js.message || "No se pudo eliminar");
  };

  // ---- VISTAS ----
  if (!logged) {
    return (
      <div style={{ maxWidth: 420, margin: "80px auto", background: "#1a1a1a", padding: 24, borderRadius: 12, color: "white" }}>
        <h2 style={{ fontWeight: 700, fontSize: 20, marginBottom: 16 }}>Login administrador</h2>
        <form onSubmit={login} style={{ display: "grid", gap: 12 }}>
          <input
            placeholder="Usuario"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            style={{ background: "#2a2a2a", color: "white", padding: "10px 12px", borderRadius: 8, border: "1px solid #333" }}
          />
          <input
            placeholder="Contraseña"
            type="password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            style={{ background: "#2a2a2a", color: "white", padding: "10px 12px", borderRadius: 8, border: "1px solid #333" }}
          />
          <button type="submit" style={{ padding: "10px 12px", borderRadius: 8, background: "#FFD700", color: "black", fontWeight: 700 }}>
            Entrar
          </button>
        </form>
      </div>
    );
  }

  const pages = Math.max(1, Math.ceil(total / limit));

  return (
    <div style={{ maxWidth: 1100, margin: "40px auto", color: "white" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h2 style={{ fontWeight: 700, fontSize: 22 }}>Gestión de testimonios</h2>
        <button onClick={logout} style={{ padding: "8px 12px", borderRadius: 8, background: "#e11d48" }}>Salir</button>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por nombre o texto"
          style={{ flex: 1, background: "#2a2a2a", color: "white", padding: "10px 12px", borderRadius: 8, border: "1px solid #333" }}
        />
        <button onClick={() => load(1)} style={{ padding: "10px 12px", borderRadius: 8, background: "#FFD700", color: "black" }}>
          Buscar
        </button>
        <button onClick={() => { setQ(""); load(1); }} style={{ padding: "10px 12px", borderRadius: 8, background: "#444" }}>
          Limpiar
        </button>
      </div>

      <div style={{ overflowX: "auto", border: "1px solid #333", borderRadius: 10 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#111", color: "#cbd5e1" }}>
              <th style={{ textAlign: "left", padding: 10 }}>ID</th>
              <th style={{ textAlign: "left", padding: 10 }}>Avatar</th>
              <th style={{ textAlign: "left", padding: 10 }}>Nombre</th>
              <th style={{ textAlign: "left", padding: 10 }}>Mensaje</th>
              <th style={{ textAlign: "left", padding: 10 }}>Fecha</th>
              <th style={{ textAlign: "left", padding: 10 }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={r.id} style={{ borderTop: "1px solid #333" }}>
                <td style={{ padding: 10 }}>{r.id}</td>
                <td style={{ padding: 10, minWidth: 180 }}>
                  <img
                    src={`${API_BASE}${r.avatar}`}
                    alt=""
                    style={{ width: 40, height: 40, objectFit: "cover", borderRadius: "9999px", display: "block", marginBottom: 6 }}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      const clone = [...rows];
                      clone[idx] = { ...r, _file: f };
                      setRows(clone);
                    }}
                  />
                </td>
                <td style={{ padding: 10, minWidth: 180 }}>
                  <input
                    value={r.nombre}
                    onChange={(e) => {
                      const clone = [...rows];
                      clone[idx] = { ...r, nombre: e.target.value };
                      setRows(clone);
                    }}
                    style={{ width: "100%", background: "#2a2a2a", color: "white", padding: "8px 10px", borderRadius: 8, border: "1px solid #333" }}
                  />
                </td>
                <td style={{ padding: 10, minWidth: 320 }}>
                  <textarea
                    rows={3}
                    value={r.mensaje}
                    onChange={(e) => {
                      const clone = [...rows];
                      clone[idx] = { ...r, mensaje: e.target.value };
                      setRows(clone);
                    }}
                    style={{ width: "100%", background: "#2a2a2a", color: "white", padding: "8px 10px", borderRadius: 8, border: "1px solid #333" }}
                  />
                </td>
                <td style={{ padding: 10 }}>{new Date(r.fecha).toLocaleString()}</td>
                <td style={{ padding: 10 }}>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={() => save(rows[idx])} style={{ padding: "8px 10px", borderRadius: 8, background: "#059669" }}>
                      Guardar
                    </button>
                    <button onClick={() => delRow(r.id)} style={{ padding: "8px 10px", borderRadius: 8, background: "#e11d48" }}>
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#9ca3af" }}>
                  Sin resultados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8, marginTop: 16 }}>
        <button onClick={() => load(page - 1)} disabled={page <= 1} style={{ padding: "6px 10px", borderRadius: 8, background: "#444" }}>
          ‹
        </button>
        <span>Página {page} de {Math.max(1, Math.ceil(total / limit))}</span>
        <button onClick={() => load(page + 1)} disabled={page >= Math.ceil(total / limit)} style={{ padding: "6px 10px", borderRadius: 8, background: "#444" }}>
          ›
        </button>
      </div>
    </div>
  );
}
